<template>
  <div class="custom-table__state">
    <mds-loader v-if="loading" />
    <mds-empty-state v-else :title="title" :message="description" />
  </div>
</template>

<script>
import MdsLoader from '@mds/loader'
import MdsEmptyState from '@mds/empty-state'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../../config/i18n'
import isEqual from 'lodash/isEqual'
import { NOT_FOUND } from '../config/constants'

export default {
  components: {
    MdsEmptyState,
    MdsLoader,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    state: {
      type: String,
      default: () => 'empty',
    },
    tableType: {
      type: String,
      default: () => 'feeds',
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    title() {
      return isEqual(this.state, NOT_FOUND)
        ? this.translate(`table.${this.state}.title`)
        : this.translate(`table.${this.tableType}.${this.state}.title`)
    },
    description() {
      return isEqual(this.state, NOT_FOUND)
        ? this.translate(`table.${this.state}.description`)
        : this.translate(`table.${this.tableType}.${this.state}.description`)
    },
  },
}
</script>
<style lang="scss">
@import '@mds/constants';

.custom-table__state {
  margin: $mds-space-5-x auto;

  & > div {
    margin: 0 auto;
  }
}
</style>
